import { type HttpPatch, mapServerError } from '@/shared/infra/http'
import type { EnableClubFeatures, EnableClubFeaturesResult } from '@/shared/domain'

export class SupabaseEnableClubFeaturesRepository {
  constructor(private readonly http: HttpPatch) {}

  execute: EnableClubFeatures = async (params) => {
    try {
      return await this.http.patch<
        { orgId: string; orgType: 'club' | 'outfitter'; enabled: boolean },
        EnableClubFeaturesResult
      >({
        url: '/org-settings/club-features',
        body: {
          orgId: params.orgId,
          orgType: params.orgType,
          enabled: params.enabled,
        },
      })
    } catch (err) {
      mapServerError(err)
    }
  }
}
